/* eslint-disable */
import { useEffect, useState, useMemo, useCallback } from "react";
import { Alert, Button, Form, Col, Row, ListGroup, Card } from "react-bootstrap";
import "./index.css";

import dayjs from "dayjs";

const dateFormat = "MM/DD/YYYY HH:mm";

import {
  FaPager,
  FaFire,
  FaFireExtinguisher,
  FaScissors,
} from "react-icons/fa6";

import { authFetch } from "../../utils/authFetch";
import PagerDutyActivity from "../Modern/IncidentDetails/PagerDutyActivity";

const PageLeadership = ({ NewRelic, ...props }) => {
  const [problemNumber, setProblemNumber] = useState("");
  const [incident, setIncident] = useState("");

  const [outage, setOutage] = useState({
    workflow_invocations: [],
  });

  const configuration = props.configuration;

  const [enablePagingButton, setEnablePagingButton] = useState(false);

  // Generated by GitHub Copilot
  // Simplified state management using consolidated workflow data
  const [consolidatedWorkflows, setConsolidatedWorkflows] = useState({
    commander: [],
    leadership: [],
    priority: [],
    businessLiaison: [],
    executedCount: 0,
    unexecutedCount: 0,
  });

  const [workflowsSelected, setWorkflowsSelected] = useState({});

  const [workflowsExecuted, setWorkflowsExecuted] = useState([]);
  const [workflowMarkup, setWorkflowMarkup] = useState("");

  const [pagerDutyDescription, setPagerDutyDescription] = useState("");

  const [outageNumber, setOutageNumber] = useState("");

  const [pagingSpinner, setPagingSpinner] = useState(true);

  const [showPagingForm, setShowPagingForm] = useState(false);
  const [missingCriteria, setMissingPagingCriteria] = useState([]);

  const [error, setError] = useState("");

  const [checks, setChecks] = useState([]);

  const [iteration, setIteration] = useState(0);

  // Generated by GitHub Copilot
  // Optimize workloadEvent with useCallback to prevent unnecessary re-renders
  const workloadEvent = useCallback(
    ({ target: { id, value, checked } }) => {
      // Generated by GitHub Copilot
      // Avoid mutating state directly, create new object
      const updatedSelection = { ...workflowsSelected };
      updatedSelection[id] = checked ? value : undefined;
      setWorkflowsSelected(updatedSelection);
    },
    [workflowsSelected]
  );

  useEffect(() => {
    setIncident(props.incident);
    setProblemNumber(props.problem.number);
    props.outage && setOutageNumber(props.outage.number);

    // Generated by GitHub Copilot
    // Use consolidated workflow data from backend
    let workflowsChosen = {};
    let workflows = {
      commander: [],
      leadership: [],
      priority: [],
      businessLiaison: [],
      executedCount: 0,
      unexecutedCount: 0,
    };

    // Initialize from consolidated workflows data
    if (props.consolidatedWorkflows) {
      workflows = props.consolidatedWorkflows;

      // Generated by GitHub Copilot
      // Derive combined workflows from categorized arrays instead of using allWorkflows

      const allWorkflows = [
        ...workflows.commander,
        ...workflows.leadership,
        ...workflows.priority,
        ...workflows.businessLiaison,
      ];

      // Initialize workflow selection state from combined workflow data
      allWorkflows.forEach((wf) => {
        workflowsChosen[wf.value] = undefined;
      });
    }

    setWorkflowsSelected(workflowsChosen);
    setConsolidatedWorkflows(workflows);

    setShowPagingForm(props.showPagingForm);
    setMissingPagingCriteria(props.missingCriteria);
    // Generated by GitHub Copilot
    // Always set workflowsExecuted to ensure executed workflows display properly on initial tab navigation
    setWorkflowsExecuted(props.workflowsExecuted || []);

    const apps =
      props.impactedApplications &&
      props.impactedApplications.map((app) => {
        return app.value;
      });

    const brands =
      props.brands &&
      props.brands.map((brand) => {
        return brand.label;
      });

    const summary =
      props.impactedApplications && props.impactedApplications.length > 0
        ? [
            props.priority,
            brands.join(", "),
            apps.join(", "),
          ].join(": ")
        : "Select Impacted Applications First";

    setPagerDutyDescription(summary);
  }, [
    props.incident,
    props.problem?.number,
    props.outage?.number,
    props.consolidatedWorkflows,
    props.showPagingForm,
    props.missingCriteria,
    props.workflowsExecuted,
    props.impactedApplications,
    props.brands,
    props.priority,
  ]);

  // Generated by GitHub Copilot
  // Helper function to derive combined workflows from categorized arrays
  const getCombinedWorkflows = useCallback((consolidatedWorkflows) => {
    if (!consolidatedWorkflows) return [];

    return [
      ...(consolidatedWorkflows.commander || []),
      ...(consolidatedWorkflows.leadership || []),
      ...(consolidatedWorkflows.priority || []),
      ...(consolidatedWorkflows.businessLiaison || []),
    ];
  }, []);

  // Generated by GitHub Copilot
  // Optimize checkbox generation with useMemo to prevent unnecessary re-calculations
  const workflowCheckboxes = useMemo(() => {
    const allWorkflows = getCombinedWorkflows(consolidatedWorkflows);

    if (allWorkflows.length === 0) {
      // console.log(
      //   "[PageLeadership] No workflows available for checkbox generation"
      // );
      return [];
    }

    // Helper function to create a checkbox for a workflow
    const createWorkflowCheckbox = (wf, category) => {
      // Use the executed status from consolidated data instead of comparing with workflowsExecuted
      // US1989003 AC1: also disable while a workflow refresh is in flight
      const disabled = wf.executed || props.workflowsRefreshing || false;
      const checkable = !disabled && workflowsSelected[wf.value];

      return (
        <Form.Check
          type="checkbox"
          key={wf.value}
          id={wf.value}
          value={wf.label}
          label={wf.label}
          disabled={disabled}
          checked={checkable}
          onChange={workloadEvent}
        />
      );
    };

    // Generate checkboxes by category
    const commanderChecks = consolidatedWorkflows.commander.map((wf) =>
      createWorkflowCheckbox(wf, "commander")
    );

    const leaderChecks = consolidatedWorkflows.leadership.map((wf) =>
      createWorkflowCheckbox(wf, "leadership")
    );

    // Combine priority and business liaison as "other" workflows for display
    const businessLiaisonChecks =
      consolidatedWorkflows.businessLiaison.map((wf) =>
        createWorkflowCheckbox(wf, "businessLiaison")
      );

    const businessLiaisonEmptyChecks = (
      consolidatedWorkflows.businessLiaisonEmptyBrands || []
    ).map((brandName) => (
      <Form.Check
        key={`no-bl-${brandName}`}
        type="checkbox"
        label={`No Business Liaison Workflow(s) for - ${brandName}`}
        disabled
        className="text-muted"
      />
    ));

    const otherChecks = [
      ...consolidatedWorkflows.priority.map((wf) =>
        createWorkflowCheckbox(wf, "priority")
      ),
      ...businessLiaisonChecks,
      ...businessLiaisonEmptyChecks,
    ];

    const checks = commanderChecks.concat(leaderChecks).concat(otherChecks);

    return checks;
  }, [
    consolidatedWorkflows,
    workflowsSelected,
    workloadEvent,
    getCombinedWorkflows,
    props.workflowsRefreshing,
  ]);

  // Generated by GitHub Copilot
  // Set the checkboxes when the memoized value changes
  useEffect(() => {
    setChecks(workflowCheckboxes);
  }, [workflowCheckboxes]);

  useEffect(() => {
    // Generated by GitHub Copilot
    // Display executed workflows using workflowsExecuted data with time and user information
    const noWorkflows = workflowsExecuted.length === 0;

    const markup = !noWorkflows ? (
      workflowsExecuted.map((invocation, index) => {
        // Generated by GitHub Copilot
        // Format the execution timestamp using dayjs
        const executionTime = dayjs
          .unix(invocation.invocation)
          .format(dateFormat);

        return (
          <ListGroup.Item key={`${invocation.workflow.value}-${index}`}>
            <div>
              <strong>{invocation.workflow.label}</strong>
            </div>
            <small className="text-muted">
              Executed by {invocation.agent} at {executionTime}
            </small>
          </ListGroup.Item>
        );
      })
    ) : (
      <ListGroup.Item>No workflows executed</ListGroup.Item>
    );

    setWorkflowMarkup(markup);
    setTimeout(() => {
      // console.log("[PageLeadership] Paging spinner disabled after timeout");
      setPagingSpinner(false);
    }, 2000);
  }, [workflowsExecuted]);

  // Generated by GitHub Copilot
  // Notify parent component when unexecuted workflow count changes
  useEffect(() => {
    if (props.onUnexecutedCountChange) {
      const unexecutedCount = consolidatedWorkflows.unexecutedCount || 0;
      props.onUnexecutedCountChange(unexecutedCount);
    }
  }, [consolidatedWorkflows.unexecutedCount, props.onUnexecutedCountChange]);

  const addResponder = (option) => {
    setPagingSpinner(true);

    let workflows = [];
    // Generated by GitHub Copilot
    // Create a new object instead of mutating the existing one
    let clearedWorkflowsSelected = {};

    for (const [key, value] of Object.entries(workflowsSelected)) {
      if (value) {
        workflows.push({ value: key, label: value });
      }
      // Initialize the cleared state without mutating the original
      clearedWorkflowsSelected[key] = undefined;
    }

    // Generated by GitHub Copilot
    // Retrieve user data from local storage per US1779471
    // This provides author information for the workflow trigger
    let authorName = "Unknown";
    let authorEmail = "";
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      try {
        const user = JSON.parse(storedUser);
        authorName = user.name || "Unknown";
        authorEmail = user.email || "";
      } catch (error) {
        console.error("Error parsing user from localStorage:", error);
      }
    }

    const payload = {
      trigger: {
        incident: incident,
        workflows: workflows,
        description: pagerDutyDescription,
        // Generated by GitHub Copilot
        // Author information from local storage per US1779471
        author: {
          name: authorName,
          email: authorEmail,
        },
      },
    };

    let requestOptions = {
      method: "POST",
      headers: { "Content-type": "application/json" },
      body: JSON.stringify(payload),
    };

    setError("");

    authFetch(
      `/api/v1/problem/${problemNumber}/${outageNumber}/workflow`,
      requestOptions
    )
      .then((res) => {
        // Generated by GitHub Copilot
        // Handle HTTP 424 (Failed Dependency) for validation failures
        if (res.status === 424) {
          // Parse the error response to distinguish between different validation failures
          return res.json().then((errorData) => {
            if (
              errorData.error &&
              errorData.error.includes(
                "update the PagerDuty Incident Description to include the impacted location"
              )
            ) {
              throw new Error("LOCATION_VALIDATION_ERROR");
            } else {
              throw new Error("CONFERENCE_BRIDGE_ERROR");
            }
          });
        }

        // Generated by GitHub Copilot
        // Handle HTTP 500 (Internal Server Error) for workflow trigger failures
        if (res.status === 500) {
          return res.json().then((errorData) => {
            // Throw a custom error type with the actual error message from the server
            const errorMessage =
              errorData.error || "Unknown server error occurred";
            throw new Error("WORKFLOW_TRIGGER_ERROR:" + errorMessage);
          });
        }

        if (!res.ok) {
          // Handle other error responses - try to get the error message from the response
          return res
            .json()
            .then((errorData) => {
              const errorMessage =
                errorData.error || `HTTP error! status: ${res.status}`;
              throw new Error("API_ERROR:" + errorMessage);
            })
            .catch((parseError) => {
              // If JSON parsing fails, throw a generic error
              if (
                parseError.message &&
                parseError.message.startsWith("API_ERROR:")
              ) {
                throw parseError;
              }
              throw new Error(`HTTP error! status: ${res.status}`);
            });
        }
        return res;
      })
      .then((res) => res.json())
      .then((result) => {
        // Generated by GitHub Copilot
        // Use consolidated workflow data from Milestone 3 API enhancement
        if (result.consolidatedWorkflows) {
          // Update with fresh consolidated workflow data that includes execution status
          setConsolidatedWorkflows(result.consolidatedWorkflows);
          // Generated by GitHub Copilot
          // Clear workflow selections only after successful API response (US1808300)
          setWorkflowsSelected(clearedWorkflowsSelected);

          // Generated by GitHub Copilot
          // Also update workflowsExecuted with the new execution data that includes timestamp and agent
          if (result.workflows) {
            setWorkflowsExecuted(result.workflows);
          }
          NewRelic?.addPageAction("Workflow.Executed", {
            problemNumber,
            workflowCount: workflows.length,
          });
          setPagingSpinner(false);
          return;
        }

        if (result.error) {
          // console.log("[PageLeadership] Error in response:", result.error);
          setError(result.error);
        }
        setPagingSpinner(false);
      })
      .catch((err) => {
        const errorType = err.message === "CONFERENCE_BRIDGE_ERROR" ? "conference_bridge"
          : err.message === "LOCATION_VALIDATION_ERROR" ? "location_validation"
          : err.message?.startsWith("WORKFLOW_TRIGGER_ERROR:") ? "workflow_trigger"
          : err.message?.startsWith("API_ERROR:") ? "api_error"
          : "unknown";
        NewRelic?.noticeError(err);
        NewRelic?.addPageAction("Workflow.Failed", {
          problemNumber,
          errorType,
          errorMessage: err?.message,
        });

        // Generated by GitHub Copilot
        // Handle conference bridge validation error with specific message
        if (err.message === "CONFERENCE_BRIDGE_ERROR") {
          setError(
            "STOP: Request the Command Center to add the conference bridge information to the PagerDuty incident through the ServiceNow incident. After this action is complete, please try sending the leadership pages again."
          );
        } else if (err.message === "LOCATION_VALIDATION_ERROR") {
          // Generated by GitHub Copilot
          // Handle location validation error with specific message
          setError(
            "STOP: You must update the PagerDuty Incident Description to include the impacted location."
          );
        } else if (
          err.message &&
          err.message.startsWith("WORKFLOW_TRIGGER_ERROR:")
        ) {
          // Generated by GitHub Copilot
          // Handle workflow trigger failures with the actual error message from PagerDuty
          const errorMessage = err.message.replace(
            "WORKFLOW_TRIGGER_ERROR:",
            ""
          );
          setError(
            "WORKFLOW TRIGGER FAILED: " +
              errorMessage +
              ". Please try again or contact support if the issue persists."
          );
          console.error(
            "[PageLeadership] Workflow trigger failed:",
            errorMessage
          );
        } else if (err.message && err.message.startsWith("API_ERROR:")) {
          // Generated by GitHub Copilot
          // Handle other API errors with the actual error message
          const errorMessage = err.message.replace("API_ERROR:", "");
          setError(errorMessage);
          console.error("[PageLeadership] API error:", errorMessage);
        } else {
          // Handle network or other errors gracefully
          setError(err.message || "An error occurred while executing workflow");
          console.error("[PageLeadership] Unexpected error:", err);
        }
        setPagingSpinner(false);
      });
  };

  const host =
    configuration && configuration.hostname
      ? configuration.hostname
      : "coxauto";

  const link = `https://${host}.pagerduty.com/incidents/${incident}/timeline`;

  const handleDescriptionChange = (e) => {
    setPagerDutyDescription(e.target.value);
  };

  const message = "";

  return incident !== "" ? (
    <span>
      <Row>
        <Col xs={6} md={6} lg={4} xl={4}>
          <a href={link} target="_blank">
            <Button className="d-flex align-items-center gap-2">
              <FaPager /> View Incident Timeline
            </Button>
          </a>
        </Col>
        <Col>
          <Button
            className="d-flex align-items-center gap-2"
            variant="warning"
            onClick={() => {
              props.disconnectPagerDuty();
            }}
          >
            <FaScissors /> Disconnect PD Incident
          </Button>
        </Col>
      </Row>

      <Row>
        {showPagingForm ? (
          <>
            <Row>
              <Col>
                <Form.Label>Current PagerDuty Incident ID</Form.Label>
              </Col>
              <Col>{incident}</Col>
            </Row>
            <Row>
              <Col xs={12} md={12} lg={6} xl={6}>
                <Form.Group className="mb-3" controlId="description">
                  <Form.Label>PagerDuty Incident Description</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder=""
                    value={pagerDutyDescription}
                    readOnly={false}
                    onChange={handleDescriptionChange}
                  />
                  <Form.Text className="text-muted">
                    This will be the PagerDuty incident title
                  </Form.Text>
                </Form.Group>
              </Col>
            </Row>
            {props.isStale && (
              <Alert variant="warning" className="mb-2">
                Workflow list may not reflect the latest changes.
              </Alert>
            )}
            {props.workflowLoadError === true && (
              <Alert variant="danger" className="mb-2">
                Workflows failed to load &mdash; paging is blocked until the list refreshes successfully
              </Alert>
            )}
            <Col xs={6} md={6} lg={6} xl={6}>
              <Row>
                <Col xs={12} md={11} lg={10} xl={10}>
                  <Form.Group className="mb-3" controlId="pageCommanders">
                    <Form.Label>Workflows</Form.Label>
                    {props.workflowsRefreshing && (
                      <div className="d-flex align-items-center gap-2 mb-2">
                        <img src="/images/24.gif" width={16} height={16} alt="Loading" />
                        <small className="text-muted">Refreshing workflows&hellip;</small>
                      </div>
                    )}
                    {checks}
                  </Form.Group>
                </Col>
                <Col xs={12} md={12} lg={1} xl={1}>
                  <Form.Label>&nbsp;</Form.Label>
                  <Button
                    id="commander"
                    variant="secondary"
                    disabled={pagingSpinner || props.workflowsRefreshing || props.workflowLoadError || props.isStale}
                    onClick={addResponder}
                  >
                    Run
                  </Button>
                </Col>
              </Row>
            </Col>
          </>
        ) : (
          <Col xs={6} md={6} lg={6} xl={6}>
            <Form.Label style={{ color: "red" }}>
              <FaFire />
              &nbsp; Not all criteria for paging have been met &nbsp; <FaFire />
            </Form.Label>

            {missingCriteria.map((m) => {
              return (
                <p key={m} className="d-flex align-items-center gap-2">
                  <FaFireExtinguisher />
                  {m}
                </p>
              );
            })}
          </Col>
        )}
        <Col xs={6} md={6} lg={6} xl={6}>
          <Row>
            <Col xs={12} md={12} lg={12} xl={12}>
              <Form.Label>&nbsp;</Form.Label>

              <Card border={error == "" ? "success" : "danger"}>
                <Card.Body>
                  <Card.Header>
                    <FaPager /> &nbsp; PagerDuty Workflows
                  </Card.Header>
                  {error ? (
                    <>
                      <Card.Body>
                        <Card.Text>ERROR: {error}</Card.Text>
                      </Card.Body>
                      <hr style={{ margin: "0", borderColor: "#dee2e6" }} />
                    </>
                  ) : (
                    <></>
                  )}
                  {pagingSpinner ? (
                    <Card.Img
                      variant="bottom"
                      src="/images/24.gif"
                      style={{
                        margin: "15px 0 10px 20px",
                        width: 25,
                        height: 24,
                      }}
                      fluid="true"
                    ></Card.Img>
                  ) : (
                    <ListGroup variant="flush">{workflowMarkup}</ListGroup>
                  )}
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Col>
      </Row>
      {problemNumber && outageNumber && (
        <Row>
          <Col>
            <PagerDutyActivity
              problemID={problemNumber}
              outageID={outageNumber}
              isActive={!(props.outage && props.outage.status && String(props.outage.status).toLowerCase() === "resolve")}
            />
          </Col>
        </Row>
      )}
    </span>
  ) : (
    <></>
  );
};

export default PageLeadership;
